import { createCommentCountConfig } from '../config';

export function prepareArgs(args) {
	if (!args || !Array.isArray(args)) {
		throw new Error('discussionFetchCommentCount - invalid args');
	} else if (args.length === 1 && Array.isArray(args[0])) {
		return { entityIds: args[0], config: createCommentCountConfig() };
	} else if (
		args.length === 2 &&
		Array.isArray(args[0]) &&
		typeof args[1] === 'object'
	) {
		return { entityIds: args[0], config: createCommentCountConfig(args[1]) };
	} else {
		return { entityIds: args, config: createCommentCountConfig() };
	}
}
